import { createEnum } from "@redotech/zod/zod-enum";
import * as z from "zod/v4";

export enum IntegrationKey {
  AIMS360 = "aims360",
  APPAREL_MAGIC = "apparel-magic",
  AUTHORIZENET = "authorizenet",
  BLUE_YONDER = "blue-yonder",
  BRIGHTPEARL = "brightpearl",
  CLOUDX = "cloudx",
  COMMENT_SOLD = "comment-sold",
  CREDITSYARD = "creditsyard",
  CUSTOM_RETURN = "custom-return",
  FLEXPORT = "flexport",
  GLOBALE = "globale",
  IDF_SHIPPING = "idf-shipping",
  INMAR = "inmar",
  KATANA = "katana",
  KLAVIYO = "klaviyo",
  LOOP = "loop",
  LUMINOUS = "luminous",
  NETSUITE = "netsuite",
  PURPLE_DOT = "purple-dot",
  REFUNDID = "refundid",
  RETURNBEAR = "returnbear",
  RISE_AI = "rise-ai",
  RIVO = "rivo",
  SEKO = "seko",
  SHIPBOB = "shipbob",
  SHIPEDGE = "shipedge",
  SHIPHERO = "shiphero",
  SHIPMONK = "shipmonk",
  TEAMWORK_COMMERCE = "teamwork-commerce",
  TRACKSTAR = "trackstar",
}

const integrationStatusSchema = z.object({ isConnected: z.boolean() });

export const getAllIntegrationStatuses = {
  name: "getAllIntegrationStatuses" as const,
  input: z.null(),
  output: z.record(createEnum(IntegrationKey), integrationStatusSchema),
};
